import React, { FC } from "react";
import ActiveClientsAvatarStack from "@src/deprecatedDesignSystem/components/ActiveClientsAvatarStack";
import useActiveClients from "@src/components/libraryItemDetailPages/course/hooks/useActiveClients";

const BuilderActiveClientsStack: FC = () => {
  const { activeClients } = useActiveClients();
  if (!activeClients?.length) return null;
  return (
    <ActiveClientsAvatarStack activeClients={activeClients} size={"32px"} />
  );
};

export default BuilderActiveClientsStack;
